import { render, staticRenderFns } from "./preliminaryReportComponent.vue?vue&type=template&id=0070ba04&scoped=true"
import script from "./preliminaryReportComponent.vue?vue&type=script&lang=js"
export * from "./preliminaryReportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070ba04",
  null
  
)

export default component.exports